import { html, nothing, render, type TemplateResult } from "lit";

const PORTAL_CLASS = "ead-body-portal";

/** Host on document.body so fixed modals are not clipped by `.content { overflow }`. */
export function getBodyPortal(): HTMLElement {
  let host = document.querySelector<HTMLElement>(`.${PORTAL_CLASS}`);
  if (!host) {
    host = document.createElement("div");
    host.className = PORTAL_CLASS;
    document.body.appendChild(host);
  }
  return host;
}

export function renderBodyPortal(template: TemplateResult | typeof nothing): void {
  render(template, getBodyPortal());
}

export function clearBodyPortal(): void {
  render(nothing, getBodyPortal());
}
